// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useQueryApi } from "api/hooks.ts";

import { languageApi } from "./api";

import GetLanguagesResponse = App.Http.Responses.Language.GetLanguagesResponse;
import GetLanguageResponse = App.Http.Responses.Language.GetLanguageResponse;


// Hook to get list of languages
export const useGetLanguagesQuery = (options = {}) => {
    return useQueryApi<GetLanguagesResponse>({
        queryKey: ["getLanguages"],
        queryFn: () => languageApi.index(),
        ...options,
    });
};

// Hook to get a specific language
export const useGetLanguageQuery = (languageId: string, options = {}) => {
    return useQueryApi<GetLanguageResponse>({
        queryKey: ["getLanguage", languageId],
        queryFn: () => languageApi.show(languageId),
        ...options,
    });
};
